import { useMocks } from '../../shared/env';
import type { TaxFilingsGateway } from './TaxFilingsGateway';
import { HttpTaxFilingsGateway } from './HttpTaxFilingsGateway';
import { MockTaxFilingsGateway } from './MockTaxFilingsGateway';

const mockGateway = useMocks ? new MockTaxFilingsGateway() : null;
export const taxFilingsGateway: TaxFilingsGateway = mockGateway ?? new HttpTaxFilingsGateway();
export type { TaxFilingsGateway } from './TaxFilingsGateway';

/** TEST-ONLY — mirrors resetMockCompanyMembershipsForTests()'s own doc comment exactly: never called by
 * any product runtime path, used only in a test file's own `beforeEach`/`afterEach` for isolation
 * (MockTaxFilingsGateway is a module-level singleton instance). */
export function resetMockTaxFilingsForTests(): void {
  mockGateway?.reset();
}
